export default function (props: any) {
    return (
        <svg
            width="26px"
            height="26px"
            viewBox="0 0 26 26"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Offcial-Online-Stroes备份" transform="translate(-272.000000, -577.000000)">
                    <g id="编组-2" transform="translate(173.000000, 345.000000)">
                        <g id="编组-6" transform="translate(99.000000, 232.000000)">
                            <path
                                d="M0,1.625 C0,0.727536875 0.612662632,0 1.36842105,0 L24.6315789,0 C25.3873579,0 26,0.727536875 26,1.625 L26,24.375 C26,25.2724875 25.3873579,26 24.6315789,26 L1.36842105,26 C0.612662632,26 0,25.2724875 0,24.375 L0,1.625 Z"
                                id="路径"
                            ></path>
                            <rect id="矩形" stroke="#919191" x="5.5" y="1.5" width="15" height="23" rx="2"></rect>
                            <path
                                d="M9,16 L9,17 L10,17 L10,18 L8,18 L8,16 L9,16 Z M18,16 L18,18 L16,18 L16,17 L17,17 L17,16 L18,16 Z M10,8 L10,9 L9,9 L9,10 L8,10 L8,8 L10,8 Z M18,8 L18,10 L17,10 L17,9 L16,9 L16,8 L18,8 Z"
                                id="形状结合"
                                fill="#919191"
                                fillRule="nonzero"
                            ></path>
                            <line x1="8.5" y1="12.5" x2="17.5" y2="12.5" id="直线" stroke="#919191" strokeLinecap="square"></line>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
